<script lang="ts">
    import type { ProductLink } from '@tile/components/product-title/ProductLink.ts';

    interface Props {
        id: string;
        link: ProductLink;
        onClick?: (event: Event) => void;
    }

    const { id, link, onClick }: Props = $props();
</script>

{#if link.index}
    <oc-link-v2
        {id}
        base64-href={btoa(link.detailPageLink)}
        data-primary-action
        data-link-type="tile"
        data-qa="find_tile__productLink"
    >
        <a href={link.href} aria-label={link.title} data-link-type="tile" onclick={onClick}></a>
    </oc-link-v2>
{:else}
    <!-- svelte-ignore a11y_click_events_have_key_events -->
    <!-- svelte-ignore a11y_no_static_element_interactions -->
    <oc-link-v2
        {id}
        base64-href={btoa(link.detailPageLink)}
        data-primary-action
        oc-aria-label={link.title}
        title={link.title}
        data-link-type="tile"
        data-qa="find_tile__productLink"
        onclick={onClick}
    ></oc-link-v2>
{/if}
